import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Divider,
  Image,
  Input,
  Modal,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPhotoUrl } from "utils/common";
import Actions from "./components/Actions";
import MessageDetailModal from "./components/DetailModal";
import * as messageActions from "./slice";

function Message() {
  const dispatch = useDispatch();
  const { messages, pagination, isLoading, isProcessing, isCompleted } =
    useSelector((state) => state.message);
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [selectingMessage, setSelectingMessage] = useState(null);
  const [searchName, setSearchName] = useState("");

  useEffect(() => {
    dispatch(messageActions.fetchMessages(pagination));
  }, []);

  useEffect(() => {
    if (isCompleted) {
      setOpenDetailModal(false);
      setSelectingMessage(null);
    }
  }, [isCompleted]);

  const onOpenDetailModal = (message = null) => {
    setSelectingMessage(message);
    setOpenDetailModal(true);
  };

  const onDelete = (message) => {
    Modal.confirm({
      title: `Xác nhận xoá tin nhắn`,
      content: `Bạn có chắc chắn muốn xoá tin nhắn này?`,
      onOk: () => dispatch(messageActions.deleteMessage(message._id)),
      centered: true,
    });
  };

  const onSubmit = (message, formData) => {
    if (message._id) {
      dispatch(messageActions.updateMessage(message, formData));
    } else {
      dispatch(messageActions.createMessage(formData));
    }
  };

  const onCancel = () => {
    setOpenDetailModal(false);
    setSelectingMessage(null);
    dispatch(messageActions.setIsProcessing(false));
  };

  const onChangeNameSearch = (e) => {
    setSearchName(e.target.value);
  };

  const onSearch = () => {
    dispatch(
      messageActions.fetchMessages({
        ...pagination,
        name: searchName,
      })
    );
  };

  const onTableChange = async (pagination) => {
    dispatch(
      messageActions.fetchMessages({
        ...pagination,
        name: searchName,
      })
    );
  };

  const columns = [
    {
      title: "STT",
      align: "center",
      width: "5%",
      render: (text, record, index) => (
        <Typography.Paragraph
          copyable={{
            text: record._id,
            tooltips: ["Sao chép ID", "Đã sao chép!"],
          }}
        >
          {(pagination.current - 1) * pagination.pageSize + index + 1}
        </Typography.Paragraph>
      ),
    },
    {
      title: "Hình ảnh",
      dataIndex: "image",
      width: "280px",
      render: (image) =>
        image ? (
          <Image
            alt="Image of message"
            src={getPhotoUrl(image?.path || null)}
            width={250}
            height={100}
          />
        ) : null,
    },
    {
      title: "Tiêu đề",
      dataIndex: "title",
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "Nội dung",
      dataIndex: "content",
      render: (content) => (
        <div style={{ whiteSpace: "pre-line" }}>
          <Typography.Paragraph
            ellipsis={{
              rows: 3,
              expandable: true,
              symbol: "Xem thêm",
            }}
          >
            {content}
          </Typography.Paragraph>
        </div>
      ),
    },
    {
      title: "App",
      dataIndex: "receiverModel",
      align: "center",
      width: "8%",
    },
    {
      title: "Người nhận",
      dataIndex: "receiverType",
      align: "center",
      width: "8%",
      render: (receiverType) =>
        receiverType === "all" ? "Tất cả" : "Chỉ định",
    },
    {
      title: "Thao tác",
      align: "center",
      width: "12%",
      render: (record) => (
        <Actions
          record={record}
          onEdit={onOpenDetailModal}
          onDelete={onDelete}
        />
      ),
    },
  ];

  return (
    <>
      <Row justify="space-between" align="middle">
        <Typography.Title level={2}>Hòm thư</Typography.Title>
        <Space size="middle">
          <Input.Search
            placeholder="Tìm theo tiêu đề"
            onChange={onChangeNameSearch}
            onSearch={onSearch}
            enterButton
            allowClear
          />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => onOpenDetailModal()}
          >
            Thêm mới
          </Button>
        </Space>
      </Row>
      <Divider />
      <Table
        bordered
        loading={isLoading}
        columns={columns}
        dataSource={messages}
        rowKey={(record) => record._id}
        pagination={pagination}
        onChange={onTableChange}
      />
      {openDetailModal && (
        <MessageDetailModal
          open={openDetailModal}
          isProcessing={isProcessing}
          onSubmit={onSubmit}
          onCancel={onCancel}
          message={selectingMessage}
        />
      )}
    </>
  );
}

export default Message;
